import * as comparatorUtilities from  "../../utility/comparator";

export default ngModule => {

  ngModule.controller('OperatorStep1Ctrl', function (
    AonConfig,
    AonApplicationService,
    AonProducts,
    application,
    OperatorService,
    services,
    $scope,
    $state,
    ZohoService) {

    this.formChoices = AonConfig.formChoices;
    this.corporate = AonConfig.corporate;
    this.deployment = AonConfig.deployment;
    this.application = application;
    this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
    this.services = services;
    this.operatorFilters = OperatorService.filters;

    this.is_service_comparison_tool = this.corporate.is_service_comparison_tool;

    $scope.$parent.ctrl.scrollToId(['active-quote-banner', 'ui-view']);

    this.lhc_age_validator = {
      error_messages: {
        percentage: "Please enter an even percentage between 0% and 70%",
        number: "Please enter an age between 30 and 110",
      },
    };

    // Ensure age is integral
    this.onAgeChange = (model) => {
      if (model.age) {
        model.age = parseInt(model.age);
      }
    };

    const youth_discount_age_validation_message = "Please enter an age between 18 and 30";
    this.youth_discount_age_validator = {
      error_messages: {
        min: youth_discount_age_validation_message,
        max: youth_discount_age_validation_message,
      }
    };

    // Ensure youth discount age is integral
    this.onYouthDiscountAgeChange = (model) => {
      if (model.primary_youth_discount_age) {
        model.primary_youth_discount_age = parseInt(model.primary_youth_discount_age);
      }
      if (model.partner_youth_discount_age) {
        model.partner_youth_discount_age = parseInt(model.partner_youth_discount_age);
      }
    };

    this.onDOBChanged = (isPageLoad = false) => {

      // If we are coming back here from the comparison screen, don't trigger
      // the update to youth discount ages
      const comingFromComparison = $scope.lastRoute === '/compare';

      const setYouthDiscountAge = (field, age) => {
        if (comingFromComparison) {
          return;
        }
        if (age >= 18 && age <= 29) {
          // If this is change was triggered by the page load, only set a value if there is not already one set
          // If triggered by an actual change on DOB, always update the age
          const doUpdate = !isPageLoad || !_.get(this.application, field);
          if (doUpdate) {
            _.set(this.application, field, age);
          }
        } else if (age < 18 || age > 44) {
          _.set(this.application, field, null);
        }
      };
      const dob = _.get(this.application, 'personal.dob');
      const primaryAge = comparatorUtilities.calculateAge(dob, { financialYear: false });
      setYouthDiscountAge('policy.primary_youth_discount_age', primaryAge);
      if (this.application.hasPartner()) {
        if (primaryAge >= 30) {
          // Youth discount is only applicable where primary policy holder is under 30
          // (but an age could still be manually entered for the partner)
          _.set(this.application, 'policy.partner_youth_discount_age', null);
        } else {
          const partnerDob = _.get(this.application, 'partner.dob');
          const partnerAge = comparatorUtilities.calculateAge(partnerDob, { financialYear: false });
          setYouthDiscountAge('policy.partner_youth_discount_age', partnerAge);
        }
      }
      if (!this.showContinuousCoverQuestion()) {
        _.set(this.application, 'policy.has_continuous_cover', null);
      }
      this.onChangeHasContinuousCover(isPageLoad);
    };

    this.showYouthDiscountAge = (person) => {
      if (this.is_service_comparison_tool || !this.formChoices.is_youth_discount_available) {
        return false;
      }
      const age = comparatorUtilities.calculateAge(person.dob);
      return age >= 18 && age <= 44;
    };

    this.servicesInColumns = comparatorUtilities.splitServicesIntoColumns(services);

    const getContinuousCover = () => _.get(this.application, 'policy.has_continuous_cover', null);

    this.continuousCoverQuestionLabel = () => {
      return this.application.hasPartner() ?
          'Have you and your partner held continuous hospital cover for the last 10 consecutive years or since your 31st birthday?' :
          'Have you held continuous hospital cover for the last 10 consecutive years or since your 31st birthday?';
    };

    this.showContinuousCoverQuestion = () => {
      return comparatorUtilities.calculateCombinedRebateAge(application) > 30;
    };
    this.showLHCAgeQuestions = () => this.corporate.capture_lhc_age && getContinuousCover() === false;

    // When continuous cover yes/no changes, pre-fill the LHC ages
    this.onChangeHasContinuousCover = (isPageLoad = false) => {
      const primaryDob = _.get(this.application, 'personal.dob');
      const setAgePrimary = getContinuousCover() ? 30 : comparatorUtilities.calculateLHCAge(primaryDob);
      // const setAgePrimary = getContinuousCover() ? 30 : comparatorUtilities.calculateAge(primaryDob, { financialYear: true });
      // If this is change was triggered by the page load, only set a value if there is not already one set
      const doUpdate = !isPageLoad || !_.get(this.application, 'policy.lhc_age');
      if (doUpdate) {
        _.set(this.application, 'policy.lhc_age', setAgePrimary);
      }

      if (this.application.hasPartner()) {
        const partnerDob = _.get(this.application, 'partner.dob');
        const setAgePartner = getContinuousCover() ? 30 : comparatorUtilities.calculateLHCAge(partnerDob);
        // const setAgePartner = getContinuousCover() ? 30 : comparatorUtilities.calculateAge(partnerDob, { financialYear: true });
        const doUpdate = !isPageLoad || !_.get(this.application, 'policy.lhc_age_partner');
        if (doUpdate) {
          _.set(this.application, 'policy.lhc_age_partner', setAgePartner);
        }
      }
    };

    this.onMembershipTypeChange = () => {
      this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
      let text = AonApplicationService.getRebateTierText(application);
      this.rebate_tier_caption = text.caption;
      this.rebate_tier_description = text.description;

      this.rebate_tier_matrix_choices = [];
      const rebateAge = comparatorUtilities.calculateCombinedRebateAge(application);
      const groups = [
          { groupLabel: "Age < 65", range: [0, 65] },
          { groupLabel: "Age 65-70", range: [65, 70] },
          { groupLabel: "Age >= 70", range: [70, 200] },
      ];
      for (let i = 0; i < 3; i++) {
        const { groupLabel, range } = groups[i];
        const ageInRange = rebateAge >= range[0] && rebateAge < range[1];
        if (!rebateAge || ageInRange) {
          for (let j = 0; j < this.rebate_tier_choices.length; j++) {
            this.rebate_tier_matrix_choices.push({
              group: groupLabel,
              value: i.toString() + "," + j.toString(),
              tier: this.rebate_tier_choices[j][1],
            });
          }
        }
      }

      // Update the previous health fund membership type if applicable and not already set
      const policyMembership = _.get(this.application, 'policy.membership_type', null);
      const hasPreviousFund  = _.get(this.application, 'personal.previous_fund.has_previous_fund', false);
      const currentHealthFundMembership = _.get(this.application, 'personal.previous_fund.membership', null);
      if (policyMembership !== null && currentHealthFundMembership === null && hasPreviousFund) {
        _.set(this.application, 'personal.previous_fund.membership', policyMembership);
      }

      if (!this.application.hasPartner()) {
          _.set(this.application, 'policy.lhc_age_partner', null);
          _.set(this.application, 'policy.partner_youth_discount_age', null);
      }
    };

    AonApplicationService.getApplication().then(applicant => {
      this.applicant = applicant;
      if (_.get(this.application, 'policy.cover_type', null) === null) {
        _.set(this.application, 'policy.cover_type', 2);
      }
    });

    /**
     * Save the applicant changes
     */
    this.onSubmit = (form) => {

      // If this applicant has a zoho id, save the selected services to zoho
      if (this.application.zoho_id) {
        const selectedServices = services => services.filter(s => s.selected).map(s => s.id);
        const applicantData = comparatorUtilities.applicantWithDOB(this.application);
        ZohoService.sendNeedsAnalysisToZoho(this.applicant.zoho_id, applicantData);
        ZohoService.saveServicesToZoho(this.application.zoho_id, {
          hospital: selectedServices(services.hospital),
          ancillary: selectedServices(services.ancillary),
        });
      }

      this.hasSubmitted = false;

      if (form.$valid) {
        AonProducts.saveServices(services);
        AonApplicationService.saveApplication(this.application);
        if (this.offerCompetition) {
            if (this.application.enter_competition) {
              // TODO(cal): send comp info to aon
              AonApplicationService.setCompetitionOptIn(); // flag as opted in, to avoid re-showing
            } else {
              AonApplicationService.setCompetitionOptOut(); // flag as opted out, to avoid re-showing
            }
        }
        $state.transitionTo('operator.step2');
      } else {
        if (form.focusInvalid) {
          form.focusInvalid();
        }
        this.hasSubmitted = true;
      }
    };


    const fundFromId = (id) => {
      let fund = this.formChoices.previous_fund.filter( e => e.id == id);
      if (fund.length) {
        return fund[0];
      } else {
        return null;
      }
    };

    this.selectPreviousFund = () => {
      const fund = fundFromId(this.application.personal.previous_fund.fund_id);
      this.application.personal.previous_fund.fund_name = fund ? fund.title : 'Unknown';
    };

    // When selecting a state, update the previous fund state as well, if it is not already set to a value
    this.selectState = () => {
      const state = _.get(this.application, 'primary_address.state', null);
      const hasPreviousFund  = _.get(this.application, 'personal.previous_fund.has_previous_fund', false);
      const currentHealthFundState = _.get(this.application, 'personal.previous_fund.state', null);
      if (state !== null && currentHealthFundState === null && hasPreviousFund) {
        _.set(this.application, 'personal.previous_fund.state', state);
      }
    };

    // If previous fund state changes, set previous fund state (if not already set) to personal state (f set),
    // same for membership type
    this.changeHasPreviousFund = () => {
      this.selectState();
      this.onMembershipTypeChange();
    }

    this.updateRebateTier = () => {
      let tier = this.application.policy.rebate_tier_matrix.split(",");
      this.application.policy.rebate_tier_age_index = parseInt(tier[0]);
      this.application.policy.rebate_tier = parseInt(tier[1]);
    };

    this.hasAnsweredCurrentFund = () => {
      const has_previous_fund = _.get(this.application, 'personal.previous_fund.has_previous_fund');
      return has_previous_fund === true || has_previous_fund === false;
    }

    // If coming from a Zoho quote, previous fund and state may already be set,
    // so check and trigger the onChange handlers if required
    if (_.get(this.application, 'personal.previous_fund.fund_id')) {
      this.selectPreviousFund();
    }
    if (_.get(this.application, 'primary_address.state')) {
      this.selectState();
    }
    this.onMembershipTypeChange();
    this.onDOBChanged(true);

    // This one needs to come after onMembershipTypeChange has set up the rebate tier choices
    const rebateTier = _.get(this.application, 'policy.rebate_tier', null);
    if (rebateTier !== null) {
      const rebateTierChoice = this.rebate_tier_matrix_choices[rebateTier];
      if (rebateTierChoice) {
        _.set(this.application, 'policy.rebate_tier_matrix', rebateTierChoice.value);
        this.updateRebateTier();
      }
    }

    const onCoverTypeChange = () => {
      const requiresHospital = this.application.requiresHospitalProducts();
      const requiresAncillary = this.application.requiresAncillaryProducts();
      if (!requiresHospital) {
        services.hospital.forEach(service => {
          service.selected = false;
        });
      }
      if (!requiresAncillary) {
        services.ancillary.forEach(service => {
          service.selected = false;
        });
      }
    };

    $scope.$watch('ctrl.application.personal.dob', this.onMembershipTypeChange);
    $scope.$watch('ctrl.application.personal.age', this.onMembershipTypeChange);
    $scope.$watch('ctrl.application.partner.dob', this.onMembershipTypeChange);
    $scope.$watch('ctrl.application.partner.age', this.onMembershipTypeChange);
    $scope.$watch('ctrl.application.policy.cover_type', onCoverTypeChange);

    this.rebateAge = () => {
      const age = comparatorUtilities.calculateRebateAge(this.application.personal);
      const endDate = comparatorUtilities.getLastFinancialYearEndDate();
      return age ? `Age ${age} as at 1 July ${endDate.getFullYear()}` : null;
    }

    this.rebateAgePartner = () => {
      if (this.application.hasPartner()) {
        const age = comparatorUtilities.calculateRebateAge(this.application.partner);
        const endDate = comparatorUtilities.getLastFinancialYearEndDate();
        return age ? `Partner age ${age} as at 1 July ${endDate.getFullYear()}` : null;
      }
    }

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/operator-step1-ctrl.js